import {
  ARCHIVED_CHAT_LIST_QUERY_KEY,
  CHAT_HISTORY_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { chatApi } from "@/api/services";

export const useArchiveChat = (onSuccess?: () => void) => {
  const { t } = useTranslation("sidebar");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (uuid: string) => chatApi.archiveChat(uuid),
    onSuccess: () => {
      onSuccess?.();
      toast.success(t("chat_list.moved_to_archive"));
      queryClient.invalidateQueries({
        queryKey: [CHAT_HISTORY_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [CHAT_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ARCHIVED_CHAT_LIST_QUERY_KEY],
      });
    },
    meta: {
      fallbackMessage: t("chat_list.archive_chat.error"),
    },
  });
};
